import React from "react";
import { Trophy } from "lucide-react";

export function MissionProgress({ mastered, total }) {
  const pct = total ? Math.round((mastered / total) * 100) : 0;
  return (
    <div className="rounded-3xl border border-[#E5DECF] bg-white p-6 sm:p-7" data-testid="mission-progress">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F59E0B]/15">
            <Trophy size={24} color="#D97706" strokeWidth={2.2} />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wide font-semibold text-[#6B7280]">Your Progress</div>
            <div className="font-heading text-xl font-extrabold text-[#1F2937]" data-testid="letters-mastered-count">
              Letters Mastered: {mastered} of {total}
            </div>
          </div>
        </div>
        <div className="font-heading text-3xl font-extrabold text-[#0D9488]">{pct}%</div>
      </div>
      <div className="mt-4 h-4 w-full overflow-hidden rounded-full bg-[#F2ECE1]" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#0D9488] to-[#0284C7] transition-all duration-700"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
